import { BaseStorage } from './base-storage';

export const LocalStorage = new BaseStorage(globalThis.localStorage, {
	onSet(key, value) {
		this.dispatchEvent(new CustomEvent('set', { detail: { key, value } }));
	},
	onRemove(key) {
		this.dispatchEvent(new CustomEvent('remove', { detail: { key } }));
	},
});
